query competitionSubscription($id: UUID!) {
  competition: competitionByCompetitionId(competitionId: $id) {
    competitionId
    core: subscribedCompetitionsByCompetitionId {
      totalCount
      nodes {
        pricingMode
        isOfferedLive
        isOfferedPreMatch
      }
    }
    sameGameParlays: sgpSubscribedCompetitionsByCompetitionId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    playerProps: playerPropsSubscribedCompetitionsByCompetitionId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    micro: microSubscribedCompetitionsByCompetitionId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    feedConfigurations: competitionFeedConfigurationsByCompetitionId {
      nodes {
        competitionId
        coverageExpected
        feed
        marketCategories
        priority
      }
    }
  }
}
